import React from "react";
import { useParams } from "react-router-dom";

import Panel from "ui/Panel";
import PageContent from "ui/PageContent";
import Form from "ui/Form";
import FormSubmit from "ui/FormSubmit";
import Loading from "ui/Loading";
import RoleForm from "features/Organization/RoleForm";

import { useRoleNewQuery } from "./gql/Query.generated";
import { useRoutes } from "utils/routes";

const RoleNew: React.FunctionComponent = () => {
  const { slug: organizationSlug } = useParams();
  const { organizationRoles } = useRoutes();
  const { data, loading, error } = useRoleNewQuery({
    variables: { organizationSlug },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }
  const { name } = data.getOrganizationDetails;
  return (
    <PageContent
      title={`Organization "${name}"`}
      pageCategory="organization-roles"
      pageName="new"
    >
      <Panel title="Create Role">
        <Form
          action={organizationRoles(organizationSlug)}
          className="!max-w-6xl"
        >
          <RoleForm organizationSlug={organizationSlug} />
          <FormSubmit title="Create Role" />
        </Form>
      </Panel>
    </PageContent>
  );
};

export default RoleNew;
